'use strict';

var Choreographer = require('./Choreographer');
module.exports = Choreographer;

window.Choreographer = Choreographer;


//////////////////
// WEBPACK FOOTER
// ./~/choreographer-js/dist/index.js
// module id = 46
// module chunks = 1